module.exports = __webpack_public_path__ + "media/V123.550ad40c.mp4";